import classnames from 'classnames';
import React from 'react';
import { FragmentConfig } from '../types';
import { Entity, ViewMetadata, ViewRequest } from '../../graphql/generated/graphql';
import Row from './Row';

import styles from './table.module.scss';

interface TableComponentProps {
  className?: string;
  config: FragmentConfig;
  headers: string[];
  loading: boolean;
  metadata: ViewMetadata[];
  entityRequest?: ViewRequest;
  rows: Entity[];
  rowStartCount?: number;
}

function getTableHeaderColSpan(idx: number, showRowNumber: boolean, showIcon: boolean): number {
  if (idx === 0) {
    if (showRowNumber && showIcon) {
      return 3;
    } else if (showRowNumber || showIcon) {
      return 2;
    }
  }
  return 1;
}

const TableComponent = React.memo(
  ({ config, rows, metadata, headers, className, loading, entityRequest, rowStartCount }: TableComponentProps) => {
    const showRowNumber = !!config.visualisations[0].showRowNumber;
    const showIcon = !!config.visualisations[0].showIcon;

    return loading || rows.length > 0 ? (
      <els-results-view-table class={classnames(styles.scopusTable, className)}>
        <table>
          <caption>{config.description}</caption>
          <thead>
            <tr>
              {headers.map(
                (header, i) =>
                  header && (
                    <th
                      colSpan={getTableHeaderColSpan(i, showRowNumber, showIcon)}
                      scope="col"
                      key={i}
                      className={classnames(styles.headerCell, {
                        [styles.currencyValue]: metadata?.[i]?.type === 'CURRENCY',
                      })}
                    >
                      {header}
                    </th>
                  ),
              )}
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr className={styles.rowLoading}>
                <td colSpan={headers.length + getTableHeaderColSpan(0, showRowNumber, showIcon) - 1}>
                  <els-skeleton count={5} />
                </td>
              </tr>
            )}
            {!loading &&
              rows.map((row: Entity, idx: number) => (
                <Row
                  rowNumber={idx + 1 + (rowStartCount ?? 0)}
                  config={config}
                  row={row}
                  key={row.id}
                  metadata={metadata}
                  entityRequest={entityRequest}
                  iconCode={row.icon}
                />
              ))}
          </tbody>
        </table>
      </els-results-view-table>
    ) : (
      <p>{config.emptyStateMessage}</p>
    );
  },
);

TableComponent.displayName = 'TableComponent';

export default TableComponent;
